import { render, staticRenderFns } from "./PublicTemplate.vue?vue&type=template&id=4909204c&scoped=true&"
import script from "./PublicTemplate.vue?vue&type=script&lang=js&"
export * from "./PublicTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PublicTemplate.vue?vue&type=style&index=0&id=4909204c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4909204c",
  null
  
)

export default component.exports